import { CKButton } from '@clearkit/react';
import { Helmet } from 'react-helmet';
import { Subscribe } from 'unstated';

import Layout from '~/components/Layout';
import LoadingArea from '~/components/LoadingArea';
import Page from '~/components/Page';
import FormsContainer from '~/containers/Forms';
import FormIcon from '~/images/Tiles/Forms/Form.svg';
import FormsIcon from '~/images/Tiles/Forms/Forms.svg';

import AppBar from './form/AppBar';
import ListForms from './ListForms';
import NewFormDialog from './NewFormDialog';
import ShowForm from './ShowForm';

class Forms extends React.Component {
  state = {
    newFormDialog: false,
  };

  showNewFormDialog = () => {
    this.setState({ newFormDialog: true });
  };

  onNewFormDialogClose = (shouldCreate, params, container) => {
    this.setState({ newFormDialog: false });

    if (shouldCreate) {
      container.createForm(params);
    }
  };

  renderForm = (container) => {
    const { form } = container.state;
    const { action } = this.props;

    return (
      <Layout
        title={form?.name || 'Loading...'}
        shadow
        tile={<FormIcon />}
        breadcrumb={[{ title: 'Forms', path: '/forms' }]}
        subtitle="Manage forms"
        tabs={<AppBar form={form} action={action} />}>
        {!form ? (
          <LoadingArea loading />
        ) : (
          <ShowForm
            action={action}
            form={form}
            onChange={container.updateForm}
            onShowListForms={() => container.setForm(null)}
            onRefreshForm={container.refreshForm}
            onSave={container.saveForm}
          />
        )}
      </Layout>
    );
  };

  renderListForms = (container, createForm, deleteForm) => {
    const { forms, loading } = container.state;

    const { newFormDialog } = this.state;

    return (
      <Layout
        title="Forms"
        tile={<FormsIcon />}
        shadow
        subtitle="Manage forms"
        actions={
          <CKButton
            variantColor="green"
            disabled={loading}
            variant="bold"
            onClick={this.showNewFormDialog}>
            New form
          </CKButton>
        }>
        <Page>
          <Helmet>
            <title>Forms</title>
          </Helmet>

          <NewFormDialog
            forms={forms}
            open={newFormDialog}
            onClose={(shouldCreate, params) => {
              this.onNewFormDialogClose(shouldCreate, params, container);
            }}
          />

          <ListForms
            forms={forms}
            loading={loading}
            createForm={createForm}
            deleteForm={deleteForm}
          />
        </Page>
      </Layout>
    );
  };

  render() {
    const { id } = this.props;
    return (
      <Subscribe to={[FormsContainer]}>
        {(container) =>
          id
            ? this.renderForm(container)
            : this.renderListForms(
                container,
                (params) => container.createForm(params),
                (params) => container.deleteForm(params),
              )
        }
      </Subscribe>
    );
  }
}

export default Forms;
